// extracted by mini-css-extract-plugin
module.exports = {"lia-section-header":"QuiltSectionHeader_lia-section-header__fH6o7","lia-section-description":"QuiltSectionHeader_lia-section-description__goW1o"};